<template>
  <ul :class="classes()">
    <li v-for="(listItem, index) in listItems" :key="index" :class="`${el}__listItem`">
      <Icon
        v-if="iconArray ? iconArray[index] : iconName"
        :class="`${el}__icon`"
        :name="iconArray ? iconArray[index] : iconName"
        :color="colorArray ? colorArray[index] : iconColor"
        size="xl"
      />
      <span
        :class="`${el}__listItemInner ${
          colorArray ? el + '__listItemInner--' + colorArray[index] : ''
        }`"
      >
        {{ listItem }}
      </span>
    </li>
  </ul>
</template>

<script>
import Icon from '../Icon';
import { ColorTypes } from '@/constants/enums';
export default {
  name: 'UnorderedList',
  components: { Icon },
  props: {
    listItems: {
      type: Array,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'supportSuccess',
      validator: (val) => ColorTypes.includes(val),
    },
    iconName: {
      type: String,
      required: false,
    },
    iconArray: {
      type: Array,
      required: false,
    },
    colorArray: {
      type: Array,
      required: false,
    },
    hideNativeListTypes: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'm',
      validator: (val) => ['s', 'm'].includes(val),
    },
    horizontal: {
      type: Boolean,
    },
    bold: Boolean,
    noMarginListItems: Boolean,
    className: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      el: 'o-unorderedList',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--bold`]: this.bold,
          [`${el}--noMarginListItems`]: this.noMarginListItems,
          [`${el}--${this.size}`]: this.size,
          [`${el}--horizontal`]: this.horizontal,
          [`${el}--hideNativeListTypes`]:
            this.hideNativeListTypes || this.iconName || this.iconArray,
        };
      },
    };
  },
};
</script>
